module.exports = __webpack_public_path__ + "d4be217de64e945e73432506d193ac86.svg";